module.exports = __webpack_public_path__ + "img/chart2.e78148ec.png";